import { Link } from '@tanstack/react-router';
import { useCampaignRace } from '@/hooks/queries';
import { getCampaignTodayString } from '@/lib/calendarUtils';
import { countdownWords, dayWords, daysUntil, fmt, stageName, stageTitle } from './goalWords';

/** Home's one number: the goal for the campaign's next election, with the time left in campaign time. */
export function VoteGoalCard() {
  const { data: link } = useCampaignRace();
  if (link === undefined) return null;

  const today = getCampaignTodayString();
  const next = link?.stages.find((s) => !s.date || s.date >= today);
  const shell = 'flex flex-wrap items-center justify-between gap-x-6 gap-y-2 rounded-xl border bg-card px-5 py-4';

  if (!link || !next?.current)
    return (
      <section className={shell} aria-label="Vote goal">
        <p className="text-sm text-muted-foreground">
          {link ? `You haven’t set a goal for the ${stageName(next?.stage ?? link.stages[0].stage)} yet.` : 'Know how many votes it takes to win.'}
        </p>
        <Link to="/app/vote-goal" className="text-sm font-semibold text-primary hover:underline">
          Set your vote goal
        </Link>
      </section>
    );

  return (
    <section className={shell} aria-label="Vote goal">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight tabular-nums">Aim for {fmt(next.current.goal)} votes</h2>
        <p className="text-sm text-muted-foreground">
          {stageTitle(next.stage)} for {link.raceName}
          {next.date && ` · ${dayWords(next.date)}, ${countdownWords(daysUntil(next.date, today))}`}
        </p>
      </div>
      <Link to="/app/vote-goal" className="text-sm font-semibold text-primary hover:underline">
        Change my goal
      </Link>
    </section>
  );
}
